/* Public Pages */
import forgottenPassword from './pages/Public/forgottenPassword';
import freebies from './pages/Public/freebies';
import landing from './pages/Public/landing';
import login from './pages/Public/login';
import mfa from './pages/Public/mfa';
import products from './pages/Public/products';
import registration from './pages/Public/registration';
import signUp from './pages/Public/signUp';

/* Private Pages */
import billing from './pages/Private/billing';
import contacts from './pages/Private/contacts';
import dashboard from './pages/Private/dashboard';
import links from './pages/Private/links';
import media from './pages/Private/media';
import newPasswordRequired from './pages/Private/newPasswordRequired';
import permissions from './pages/Private/permissions';
import profile from './pages/Private/profile';
import project from './pages/Private/project';
import projects from './pages/Private/projects';
import settings from './pages/Private/settings';
import tags from './pages/Private/tags';
import users from './pages/Private/users';

/* Components */
import advancedMediaSelectDrawer from './components/advancedMediaSelectDrawer';
import cookieConsentBanner from './components/cookieConsentBanner';
import file from './components/file';
import footer from './components/footer';
import header from './components/header';
import inputs from './components/inputs';
import layouts from './components/layouts';
import navigation from './components/navigation';
import notifications from './components/notifications';
import noAccess from './components/noAccess';
import productsSelect from './components/productsSelect';
import subscriptionBadge from './components/subscriptionBadge';

/* Other */
import errors from './errors';
import toastNotifications from './toastNotifications';

export default {
	//* Public Pages */
	forgottenPassword,
	freebies,
	landing,
	login,
	mfa,
	products,
	registration,
	signUp,

	/* Private Pages */
	billing,
	contacts,
	dashboard,
	links,
	media,
	newPasswordRequired,
	permissions,
	profile,
	project,
	projects,
	settings,
	tags,
	users,

	/* Components */
	advancedMediaSelectDrawer,
	cookieConsentBanner,
	file,
	footer,
	header,
	inputs,
	layouts,
	navigation,
	notifications,
	noAccess,
	productsSelect,
	subscriptionBadge,

	/* Other */
	errors,
	toastNotifications
};
